// extracted by mini-css-extract-plugin
export default {"badge":"TaskBadge_badge__K07qa"};